// ContactPage.tsx
import React from "react";
import DefaultBasePage from "../default/base";

const ContactPage: React.FC = () => {
  return (
    <DefaultBasePage title="Entre em Contato">
      <div className="text-center">
        <p>
          Gostaríamos de ouvir de você! Entre em contato conosco para mais
          informações.
        </p>
        <div className="mt-4">
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:gugart@hotmail.com">gugart@hotmail.com</a>
          </p>
          <p>
            <strong>GitHub:</strong>{" "}
            <a
              href="https://github.com/ggerminiani"
              target="_blank"
              rel="noopener noreferrer"
            >
              @ggerminiani
            </a>
          </p>
          <p>
            <strong>LinkedIn:</strong>{" "}
            <a
              href="https://linkedin.com/in/ggerminiani"
              target="_blank"
              rel="noopener noreferrer"
            >
              @ggerminiani
            </a>
          </p>
          <p>
            <strong>Instagram:</strong>{" "}
            <a
              href="https://instagram.com/ggerminiani"
              target="_blank"
              rel="noopener noreferrer"
            >
              @ggerminiani
            </a>
          </p>
        </div>
      </div>
    </DefaultBasePage>
  );
};

export default ContactPage;
